module.exports = __webpack_public_path__ + "static/media/i-got-the-fear.4a0bb2bf.txt";